"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableWidthMeasure = TableWidthMeasure;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _reactMeasure = _interopRequireDefault(require("react-measure"));
function TableWidthMeasure(_ref) {
  var children = _ref.children;
  var _useState = (0, _react.useState)(window.innerWidth),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var handleResize = (0, _react.useCallback)(function (_ref2) {
    var bounds = _ref2.bounds;
    setWidth(bounds.width);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_reactMeasure.default, {
    bounds: true,
    onResize: handleResize
  }, function (_ref3) {
    var measureRef = _ref3.measureRef;
    return children({
      width: width,
      measureRef: measureRef
    });
  });
}